import { browserSessionStore, createApiClient } from '@gatecheckpro/api-client';

/**
 * One client per surface, with its own storage key.
 *
 * The organizer workspace and the operations console are different products with
 * different authority, and a shared storage key would let a browser carry an
 * operator's session into an organizer tab. They are separate origins in
 * production; keeping the keys distinct means they behave the same way in
 * development, where they are not.
 */
/*
 * Origin-relative, deliberately.
 *
 * Each browser surface completes its own CABS ceremony against its own hostname's `/api/*`, and a
 * session established there is stored under that origin. An absolute base would send the organizer
 * console's authorization code to whichever host was compiled in — and every surface shared one
 * `VITE_API_BASE_URL` pointing at the attendee authority, so that host was the attendee's. The
 * backend is the same service, so nothing would have failed; the session would simply have been
 * established in the wrong origin.
 *
 * Relative removes the question. The API a surface calls is the host that served it, and a bundle
 * carrying no API hostname cannot carry the wrong one. Local development and the journey suite
 * reach the API through a Vite proxy on the same origin, so the shape is identical there.
 */
export const api = createApiClient({
  baseUrl: '',
  store: browserSessionStore('gatecheckpro.organizer.session'),
});
